import { Button, TextField, Typography } from "@king-ict/eupisi-ui/components";
import { ReactComponent as AddIcon } from "@king-ict/eupisi-ui/components/Icon/Add.svg";
import { ReactComponent as RemoveIcon } from "@king-ict/eupisi-ui/components/Icon/RemoveIcon.svg";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import StaticField from "../../components/StaticField";
import { Competence } from "../../models/ProgramRequest";
import { createCompetenceInitial } from "../../models/ProgramRequest/Competence";
import styles from "../ProgramRequestEdit/ProgramRequestEdit.module.scss";



export interface CompetenceInfoMzoProps {
    name: string;
    competences: Competence[];
    competencesCorrections: Competence[];
    getErrorForPath: (path: string) => string | undefined;
    onChange: (e: any) => void;
}

export function CompetenceInfoMzo({
    name,
    competences = [],
    competencesCorrections = [],
    getErrorForPath,
    onChange
}: CompetenceInfoMzoProps) {

    const { t } = useTranslation();

    const handleAdd = (event: React.MouseEvent<any, MouseEvent>) => {
        var newList = competencesCorrections.slice();
        newList.push(createCompetenceInitial());
        onChange({
            ...event,
            target: {
                ...event.target,
                name: name,
                value: newList
            }
        });
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        var newList = competencesCorrections.slice();
        newList[index].name = event.target.value;
        onChange({
            ...event,
            target: {
                ...event.target,
                name: name,
                value: newList
            }
        });
    };

    const handleRemove = (event: React.MouseEvent<any, MouseEvent>, index: number) => {
        var newList = competencesCorrections.slice();
        newList.splice(index, 1);
        onChange({
            ...event,
            target: {
                ...event.target,
                name: name,
                value: newList
            }
        });
    };


    const renderRowWithCompetence = (competence: Competence) => {
                
        var competenceCorrection = competencesCorrections.find((c) => c.sourceCompetenceId === competence.id);

        return (
            <>
                <Row>
                    <Col md={12} className={"d-flex"}>
                        <StaticField
                            label={t("request.competenceName")}
                            value={competence.name}
                        />
                    </Col>
                </Row>
                <Row>
                    {(competenceCorrection &&
                        <Col md={12} className={"d-flex"}>
                            <TextField
                                className={"w-100"}
                                value={competenceCorrection.name}
                                maxLength={512}
                                onChange={(e) => handleChange(e, competencesCorrections.indexOf(competenceCorrection!))}
                                errorText={getErrorForPath(`competences${competencesCorrections.indexOf(competenceCorrection!)}.name`)}
                            />
                            <div className={"pl-3"} style={{ marginTop: "8px" }}>
                                <Button
                                    className={`p-0 ${competencesCorrections.length > 1 ? 'visible' : 'invisible'}`}
                                    boxless
                                    disabled={competencesCorrections.length <= 1}
                                    onClick={(e) => handleRemove(e, competencesCorrections.indexOf(competenceCorrection!))}
                                >
                                    <RemoveIcon />
                                </Button>
                            </div>
                        </Col>
                    ) ||
                        (
                            <Col md={12} className={"d-flex"}>
                                <StaticField
                                    label={""}
                                    value={"--"}
                                />
                            </Col>
                        )}
                </Row>
            </>
        );
    };

    const renderRowWithoutCompetence = (competenceCorrection: Competence) => {        
        var competence = competences.find((c) => c.id === competenceCorrection.sourceCompetenceId);

        if (competence) {
            return;
        }

        return (
            <>
                <Row>
                    <Col md={12} className={"d-flex"}>
                        <StaticField
                            label={t("request.competenceName")}
                            value={"--"}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className={"d-flex"}>
                        <TextField
                            className={"w-100"}
                            value={competenceCorrection.name}
                            maxLength={512}
                            onChange={(e) => handleChange(e, competencesCorrections.indexOf(competenceCorrection))}
                            errorText={getErrorForPath(`competences${competencesCorrections.indexOf(competenceCorrection)}.name`)}
                        />
                        <div className={"pl-3"} style={{ marginTop: "8px" }}>
                            <Button
                                className={`p-0 ${competencesCorrections.length > 1 ? 'visible' : 'invisible'}`}
                                boxless
                                disabled={competencesCorrections.length <= 1}
                                onClick={(e) => handleRemove(e, competencesCorrections.indexOf(competenceCorrection))}
                            >
                                <RemoveIcon />
                            </Button>
                        </div>
                    </Col>
                </Row>
            </>
        );
    };

    return (
        <>
            <Row>
                <Col md={12} className={styles.rowTitleSpacing}>
                    <Typography variant="smallHeading" component="h3">
                        {t("request.competences")}
                    </Typography>
                </Col>
            </Row>
            {competences.map((comp) => (
                renderRowWithCompetence(comp)
            ))}
            {competencesCorrections.map((compCorrection) => (
                renderRowWithoutCompetence(compCorrection)
            ))}
            <Row className={"text-right"}>
                <Col md={12}>
                    <Button
                        outline
                        icon={<AddIcon />}

                        onClick={handleAdd}
                    >
                        {t("request.competenceAdd")}
                    </Button>
                </Col>
            </Row>
        </>
    );
}